import React from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress } from '@material-ui/core';
import { ResponsivePie } from '@nivo/pie';
import { useSwaggerClient } from '../../../../hooks/useSwaggerClient';

const StatusPieChart = ({ agentId, fromDate, toDate, dateType, status }) => {
    const [dashboardData, loading] = useSwaggerClient(
        'users/statistics',
        'getAgentActivityDashboard',
        {
            agentId,
            fromDate,
            toDate,
            dateType,
            status
        },
        [agentId, fromDate, toDate, dateType, status]
    );

    const kpis = dashboardData?.kpis || {};

    if (loading) {
        return (
            <Grid item xs={12} md={6}>
                <Card>
                    <CardContent style={{ textAlign: 'center', padding: '40px' }}>
                        <CircularProgress />
                    </CardContent>
                </Card>
            </Grid>
        );
    }

    // Prepare data for pie chart
    const pieData = [
        {
            id: 'Confirmed (Past)',
            label: 'Confirmed (Past)',
            value: parseInt(kpis.confirmedPastVouchers) || 0,
            color: '#4caf50'
        },
        {
            id: 'Confirmed',
            label: 'Confirmed',
            value: parseInt(kpis.confirmedFutureVouchers) || 0,
            color: '#2196f3'
        },
        {
            id: 'Unconfirmed',
            label: 'Unconfirmed',
            value: parseInt(kpis.unconfirmedVouchers) || 0,
            color: '#ff9800'
        },
        {
            id: 'Refunded',
            label: 'Refunded',
            value: parseInt(kpis.refundedVouchers) || 0,
            color: '#f44336'
        }
    ].filter(item => item.value > 0);

    if (pieData.length === 0) {
        return (
            <Grid item xs={12} md={6}>
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Status Distribution
                        </Typography>
                        <Typography color="textSecondary">
                            No data available for the selected period.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        );
    }

    return (
        <Grid item xs={12} md={6}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Status Distribution
                    </Typography>
                    <div style={{ height: '400px' }}>
                        <ResponsivePie
                            data={pieData}
                            margin={{ top: 30, right: 95, bottom: 30, left: 95 }}
                            innerRadius={0.5}
                            padAngle={0.7}
                            cornerRadius={3}
                            activeOuterRadiusOffset={8}
                            colors={{ datum: 'data.color' }}
                            borderWidth={1}
                            borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                            arcLinkLabelsSkipAngle={10}
                            arcLinkLabelsTextColor="#333333"
                            arcLinkLabelsThickness={1}
                            arcLinkLabelsColor={{ from: 'color' }}
                            arcLinkLabelsTextOffset={4}
                            enableArcLabels={true}
                            arcLinkLabel={d => `${d.id}`}
                            theme={{
                                labels: {
                                    text: {
                                        fontSize: 11
                                    }
                                }
                            }}
                            arcLabelsSkipAngle={10}
                            arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                        />
                    </div>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default StatusPieChart;
